import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Header = () => {
  // Access cart data from the Redux store
  const result = useSelector((state) => state.cartData);

  // Render header with logo and cart link
  return (
    <div className="header">
      <Link to="/" className="logo">
        <h1>🛍️ Cart System</h1>
      </Link>
      <Link to="/cart" className="cart-div">
        <img
          src="https://static.vecteezy.com/system/resources/previews/004/999/463/non_2x/shopping-cart-icon-illustration-free-vector.jpg"
          alt="Cart"
        />
        <span className="cart-count">{result.length}</span>
      </Link>
    </div>
  );
};

export default Header;
